// Environment Configuration File
// All values are now loaded from .env file
// This file acts as a wrapper to maintain compatibility with existing imports

const environment = {
  production: process.env.REACT_APP_PRODUCTION === 'true' || false,
  apiurlv3_webapi: process.env.REACT_APP_APIURLV3_WEBAPI || '',
  apiurl: process.env.REACT_APP_APIURL || '',
  apiurl_internal: process.env.REACT_APP_APIURL_INTERNAL || '',
  apiurlEndPoint: process.env.REACT_APP_APIURL_ENDPOINT || '',
  apiurl_agentCode: process.env.REACT_APP_APIURL_AGENTCODE || '',
  REACT_APP_FE_BASE_URL: process.env.REACT_APP_FE_BASE_URL || '',
  REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL || '',
};

export default environment;
